import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { SupportTicket } from '../entities/SupportTicket'

// Owner-scoped — the Action finds `ticketId` among the conversations `args.user` takes part in.
// `ticketId` is a conversation `_id`, or the `externalId` an older ticket link carries.
@InputType()
export class GetMySupportTicketArgs extends ActionArgs {
  @Field(() => ID)
  ticketId: string
}

export interface IGetMySupportTicket extends IAction<SupportTicket, GetMySupportTicketArgs> {}
